"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonComboBox = void 0;
const React = require("react");
const BronsonComboBox = (props) => {
    const [boxExpanded, setBoxExpanded] = React.useState(false);
    const [optionsChecked, setOptionsChecked] = React.useState(props.optionsSelected);
    const childClick = React.useRef(false);
    const one = 1;
    const onChangeOptions = (value) => {
        let newOptions = [];
        if (optionsChecked.includes(value)) {
            newOptions = optionsChecked.filter((option) => option !== value);
            setOptionsChecked(newOptions);
        }
        else {
            newOptions = [...optionsChecked, value];
            setOptionsChecked(newOptions);
        }
        props.onChange(newOptions);
    };
    const openComboBoxList = () => {
        if (childClick.current) {
            childClick.current = false;
        }
        else {
            setBoxExpanded((prev) => !prev);
        }
    };
    const comboBoxOptionClick = (name) => {
        childClick.current = true;
        onChangeOptions(name);
    };
    return (React.createElement("div", { className: 'c-combobox__wrapper  js-combobox' },
        React.createElement("input", { type: 'hidden', name: 'combobox-values', className: 'js-combobox__input-values' }),
        React.createElement("div", { onClick: openComboBoxList, role: 'combobox', "aria-haspopup": 'listbox', "aria-expanded": boxExpanded, "aria-owns": 'combo-multiple-listbox', "aria-controls": 'combo-multiple-listbox', "aria-activedescendant": '', id: 'combo-multiple', className: 'c-combobox' },
            React.createElement("div", { className: 'c-combobox__value-presentation  js-combobox-value-presentation' },
                React.createElement("span", { id: 'combo-multiple-values', className: `c-combobox__value-presentation__text ${optionsChecked.length ? '' : 'has-placeholder'}` }, optionsChecked.length
                    ? `(${optionsChecked.length}) Opcion${optionsChecked.length > one ? 'es' : ''} seleccionada${optionsChecked.length > one ? 's' : ''}`
                    : props.placeholderLabel)),
            React.createElement("div", { className: 'c-combobox__listbox-container' },
                React.createElement("div", { id: 'combo-multiple-listbox', className: 'c-combobox__listbox', role: 'listbox', "aria-multiselectable": 'true' }, props.comboBoxOptions.map((name, index) => (React.createElement("div", { key: index, onClick: () => comboBoxOptionClick(name), role: 'option', id: `combo-multiple-option-${index}`, className: 'c-combobox__item', "data-value": 'custom', "aria-selected": optionsChecked.includes(name), "aria-disabled": 'false' },
                    React.createElement("div", { className: 'c-combobox__item__text' }, name)))))))));
};
exports.BronsonComboBox = BronsonComboBox;
